// extracted by mini-css-extract-plugin
module.exports = {"auth":"AuthForm_auth__1mc3z","control":"AuthForm_control__3RfDf","actions":"AuthForm_actions__354hY","toggle":"AuthForm_toggle__3oPqN"};